import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const useUpdateSessionTrialConfigMutation = ({ trialId }) => {
  const queryClient = useQueryClient();
  const token = localStorage.getItem("token");

  return useMutation({
    mutationFn: async (payload) => {
      const res = await axios.put(
        `${__API_URL__}/api/photos/trials/${trialId}/session-config/`,
        payload,
        { headers: { Authorization: `Token ${token}` } }
      );
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["session_trial_config", trialId] });
    },
  });
};

export default useUpdateSessionTrialConfigMutation;
